// extracted by mini-css-extract-plugin
module.exports = {"app-font-size":"16","breakpoint":"breakpoint","number-lines":"number-lines","article":"RgOWlt","contentData":"JUAD6W","image":"NTCSGs","title":"xk9VHp"};